var exports = {
  "v": "xe533113f--6fd411--factoids-list",
  "l": "xe533113f--6fd411--show-more-button",
};

module.exports = exports;
